import styled, { css } from 'styled-components';

export const Container = styled.div`
  margin-left: 12px;

  @media ${({ theme }) => `(max-width: ${theme.breakPoint.DESKTOP})`} {
    margin: 0px;
  }
`;

export const LogoWrapper = styled.div`
  width: 56px;
  height: 30px;
  display: flex;
  justify-content: center;
  align-self: center;
  position: relative;
  @media ${({ theme }) => `(max-width: ${theme.breakPoint.DESKTOP})`} {
    width: 73px;
    height: 37px;
    margin-top: 20px;
  }
`;

export const Title = styled.span`
  font-size: 14px;
  text-align: center;
  display: -webkit-box;
  padding-top: 15px;
  line-height: 17.6px;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  margin: 0px 20px 0 20px;
  text-overflow: ellipsis;
  white-space: normal;
  overflow: hidden;

  @media ${({ theme }) => `(max-width: ${theme.breakPoint.DESKTOP})`} {
    font-size: 12px;
    margin-bottom: 10px;
    text-overflow: clip;
    white-space: normal;
    overflow: hidden;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
  }
  @media ${({ theme }) => `(max-width: ${theme.breakPoint.PHONE})`} {
    margin-top: -10px;
  }
  @media ${({ theme }) => `(min-width: ${theme.breakPoint.DESKTOP})`} {
    margin-top: -10px;
  }
`;

export const Description = styled.span`
  display: block;
  text-align: left;
  margin-left: 10px;
  width: calc(100% - 15px);
  display: none;
  padding-top: 10px;

  @media ${({ theme }) => `(max-width: ${theme.breakPoint.DESKTOP})`} {
    width: 95%;
  }

  @media ${({ theme }) => `(max-width: ${theme.breakPoint.TABLET})`} {
    margin-top: 10px;
  }
  @media ${({ theme }) => `(max-width: ${theme.breakPoint.PHONE})`} {
    margin-top: 10px;
  }
`;

export const TitleWrapper = styled.div`
  @media ${({ theme }) => `(max-width: ${theme.breakPoint.DESKTOP})`} {
    display: flex;
    margin-bottom: 10px;
  }
`;

export const Wrapper = styled.div<{
  isButton?: boolean;
  backgroundColor?: string;
}>`
  ${({ isButton }) => isButton && 'cursor: pointer'};
  position: relative;
  width: 174px;
  height: 86px;
  display: flex;
  justify-content: center;
  margin: 12px 8px 0px 0px;
  flex-direction: column;
  border-radius: 8px;
  padding: 8px;
  margin-bottom: 16px;
  background-color: ${({ backgroundColor, theme }) =>
    backgroundColor ?? theme.palette.NL20};

  @media ${({ theme }) => ` (max-width: ${theme.breakPoint.PHONE})`} {
    width: calc((100% - 35px) / 2);
    height: 52px;
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 20px 8px 10px 8px;
  }
`;

export const ShowMoreWrapper = styled.div`
  width: 90px;
  height: 86px;
  padding: 8px 4px;
  background-color: ${({ theme }) => theme.palette.BR50};
  display: flex;
  margin-top: 12px;
  border-radius: 8px;
  cursor: pointer;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  text-align: center;
`;

export const ModalContainer = styled.div`
  height: 452px;
  padding-right: 10px;
  overflow-y: auto;
  /* For WebKit based browsers */
  &::-webkit-scrollbar {
    width: 5px;
    cursor: pointer;
    left: 10px;
  }
  &::-webkit-scrollbar-track {
    background-color: ${({ theme }) => theme.palette.gray87};
  }
  &::-webkit-scrollbar-thumb {
    background-color: ${({ theme }) => theme.palette.D75};
  }

  @media ${({ theme }) => `(max-width: ${theme.breakPoint.DESKTOP})`} {
    height: 100vh;
    padding-bottom: 80px;
  }
`;

export const ModalItem = styled.div`
  display: flex;
  flex-direction: column;
  border-radius: 8px;
  padding: 8px;
  margin-bottom: 8px;
  background-color: ${({ theme }) => theme.palette.NL20};

  @media ${({ theme }) => `(min-width: ${theme.breakPoint.DESKTOP})`} {
    flex-direction: row;
  }
`;

export const ModalTextWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

export const ModalLogoWrapper = styled.div`
  min-width: 70px;
  display: flex;
  justify-content: flex-start;
  align-self: start;
  position: relative;

  @media ${({ theme }) => `(min-width: ${theme.breakPoint.DESKTOP})`} {
    align-self: center;
  }
`;

export const ShowOpportunities = styled.div`
  width: calc((100% - 35px) / 2);
  height: 52px;
  border-radius: 8px;
  background-color: ${({ theme }) => theme.palette.BR50};
  margin-top: 10px;
  padding: 8px 4px;
`;

export const modalCloseButtonCss = css`
  position: relative;
  right: 16px;
  color: ${({ theme }) => theme.palette.D400};
`;

export const modalContentCss = css`
  border-radius: 8px;
`;
